import React from 'react';

const AlternateProductContext = React.createContext();

export default AlternateProductContext;
